module.exports = "static/styles/images/support-link.20c0286266a82b8ccbf14138edcc9ec3.png";


//////////////////
// WEBPACK FOOTER
// ./lib/help/styles/images/support-link.png
// module id = 284
// module chunks = 0